import Slider from 'react-slick';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import React from 'react';

import { capitalizeFirstLetter, changeDateFormat, checkSingular, getShortName } from '@utils/Util';

const OrderWiseSupplier = ({ supplierList, onClick, details, isShowStatus = true }) => {
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 3,
		marginRight: 16,
		slidesToScroll: 3,
		initialSlide: 0,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 1
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	};

	const renderStatusWiseDate = (item) => {
		return (
			<div className="task-status purple">
				<span className="status-btn d-flex">
					{capitalizeFirstLetter(item.approvalStatus)}
					<span className="mx-1">|</span>
					{changeDateFormat(
						item.approvalStatus === 'COMPLETED' ? details?.completedDate : details?.requestedDate,
						'YYYY-MM-DD',
						'DD MMM'
					)}
				</span>
			</div>
		);
	};

	return (
		<div className="factory-slider-row d-block">
			<Slider {...settings}>
				{supplierList?.map((item) => (
					<div
						className={`one-fourth ${item.id === details.id ? 'active' : ''}`}
						key={item.id}
						onClick={() => onClick(item)}
					>
						<div className="f-info">
							<Tooltip title={item.supplierName} placement="top" arrow>
								<Link
									onClick={(e) => e.stopPropagation()}
									className="f-title"
									to={`/suppliers/view/${item.supplierId}`}
									target="_blank"
								>
									{getShortName(item.supplierName, 35)}
								</Link>
							</Tooltip>
							<p className="f-location regular-14">
								<img src={`${process.env.PUBLIC_URL}/icons/map-pin.svg`} alt />{' '}
								{item?.officeLocationResponse?.city},{' '}
								{item?.officeLocationResponse?.countryResponse?.name}
							</p>
						</div>
						<div className="f-status d-flex justify-content-between align-items-center mt-4">
							<p className="price-and-design regular-14">
								${parseFloat(item.productionCost).toFixed(2)}
								<span>({checkSingular('Design', item?.numberOfDesign)})</span>
							</p>

							{isShowStatus && (
								<>
									{item?.approvalStatus === 'PENDING' ? (
										<div className="task-status blue">
											<span className="status-btn d-flex">
												{capitalizeFirstLetter(item.approvalStatus)}
											</span>
										</div>
									) : (
										renderStatusWiseDate(item)
									)}
								</>
							)}
						</div>
					</div>
				))}
			</Slider>
		</div>
	);
};

export default OrderWiseSupplier;
